import React,{useState} from "react";
import { useForm } from "react-hook-form";
import { Grid, TextField, FormControl, Button, Typography, Card, CardContent, Select, InputLabel, MenuItem } from "@material-ui/core";
import { createRole } from '../../actions/role-actions';
import { yupResolver } from "@hookform/resolvers/yup";
import { REQUIRED_MESSAGE, ERROR_MESSAGE } from "../../constants";
import { styles } from '../styles';
import * as yup from "yup";

const schema = yup.object().shape({
  name: yup
  .string()
  .nullable()
  .required(REQUIRED_MESSAGE)
  .min(2, 'Ingrese mínimo 2 caracteres')
  .max(50, 'Ingrese máximo 50 caracteres')
  .matches(
    /^(?=.{0,50}$)(([A-Za-zÀ-ÿÑñ](\s|\(|\))?))+$/,
    "Ingrese un rol válido"
  ),
});

const defaultValues = { 
  name: null,
};

const CreateRol = ({ setMessage, message, resetData }) => {
  const classes = styles();
  const [submitDisabled, setSubmitDisabled] = useState(false);
 
  
  const { register, handleSubmit,  errors, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: 'onTouched',
    reValidateMode: 'onChange',
  });

  const handleClickOut = () => setMessage({...message, open: false});
  const handleClickClose = () => {setMessage({...message, open: false}); setSubmitDisabled(false);};
  
  const onSubmit = data => {
    setMessage({
      description : "¿Está seguro que desea crear el registro?",
      textButtonSubmit : 'Aceptar',
      handleClick : () => handleClick(data),
      handleClickOut: () => handleClickClose(),
      type : 'WARNING',
      open : true
  })
     
  }

  const handleClickCloseCreate = () => {
    handleClickClose();
    resetData();
    setValue('name')
    
  }

  const handleClick = (data) => {
    setSubmitDisabled(true)
    setMessage({...message, open: false});
      const create = async() => {
        const response = await createRole(data);
    
        if (response && response?.status === 200 || response?.status === 201) {
        setMessage({
          description : `Rol creado exitosamente`,
          textButtonSubmit : 'Aceptar',
          oneButtons: true,
          handleClick : () =>  handleClickCloseCreate(),
          type : 'SUCCESS',
          open : true
        })
          }  else if(response?.status > 399 && response?.status !== 401 && response?.status !==403){
            setMessage({
              description : response?.data ? response?.data?.detail : ERROR_MESSAGE,
              textButtonSubmit : 'ACEPTAR',
              handleClick : () => handleClickClose() ,
              oneButtons : true,
              type : 'WARNING',
              open : true
            })
          }  else {
            setMessage({
              description :  ERROR_MESSAGE,
              textButtonSubmit : 'Aceptar',
              handleClick : () =>  handleClickClose(),
              type : 'WARNING',
              OneButtons : true,
              open : true
            });
          }
        
      }
      create();
  }

  

  return (
    <>
    <Card elevation = {0} style={{background: '#e0f2f7'}}>
        <CardContent>
      <form onSubmit={handleSubmit(onSubmit)}  className={classes.form}>
        {/* <Typography component='h1' variant='h4' style={{textAlign:'center'}}>
          Crear Rol
        </Typography> */}
        <Grid container spacing={3} alignItems="center" style = {{background: '#BAE5F9', borderRadius: 15, display: 'flex'}}>
            <Grid item xs={12} md={6} lg={8}>
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    className = { classes.dropdown}
                    inputRef={register}
                    size = 'small'
                    required
                    placeholder="Nombre del rol"
                    defaultValue = ''
                    label="Nombre"
                    InputLabelProps = {{ shrink: true}}
                    name="name"
                    error={!!errors.hasOwnProperty("name") && errors["name"].message}
                    helperText={errors.hasOwnProperty("name") && errors["name"].message}
                />
               
            </FormControl>
            </Grid>
          <Grid item xs={12} sm={3} lg={3}>
            <Button
                  type="submit"
                  fullWidth
                  disabled = {submitDisabled}
                  variant="outlined" 
                 className = { classes.create }
              >
                GUARDAR
            </Button>
         </Grid>
        </Grid>
      </form>
      </CardContent>
      </Card>
    </>
  );
}


export default CreateRol;